import EDPMediaCarousel from 'components/Content/Happening/HappeningEDP/EDPInfo/EDPMedia/EDPMediaCarousel/EDPMediaCarousel';

export default EDPMediaCarousel;
